import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ProvisioningService } from '../../services/provisioning/provisioning.service';
import { ToastService } from '../../services/toast/toast.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';

@Component({
  selector: 'app-provision-devotee-utils',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './provision-devotee-utils.component.html',
  styleUrl: './provision-devotee-utils.component.scss',
})
export class ProvisionDevoteeUtilsComponent {
  // FC history
  familyCode = new FormControl('');
  buckets: any = null;
  fcSearched: boolean = false;
  bucketDefs = [
    { key: 'availed', label: 'Availed' },
    { key: 'upcomingConfirmed', label: 'Upcoming confirmed' },
    { key: 'upcomingPending', label: 'Upcoming pending' },
    { key: 'pastPending', label: 'Past pending' },
    { key: 'pastCancelled', label: 'Past cancelled' },
    { key: 'upcomingCancelled', label: 'Upcoming cancelled' },
    { key: 'noShow', label: 'No show' },
  ];

  // district search
  district = new FormControl('');
  districtFrom = new FormControl('');
  districtTo = new FormControl('');
  districtResults: any[] = [];
  districtSearched: boolean = false;

  // confirmation sms
  smsBookingId = new FormControl('');

  isLoading: boolean = false;

  constructor(
    private provisioningService: ProvisioningService,
    private toastService: ToastService
  ) {}

  rows(key: string): any[] {
    return (this.buckets && this.buckets[key]) || [];
  }

  get hasAnyBucket(): boolean {
    return this.bucketDefs.some((b) => this.rows(b.key).length > 0);
  }

  searchFcHistory(): void {
    const fc = (this.familyCode.value || '').trim();
    if (!fc) {
      this.toastService.error('Enter a family code.');
      return;
    }
    this.isLoading = true;
    this.provisioningService.getFcHistory(fc).subscribe({
      next: (res: any) => {
        this.buckets = res?.data || null;
        this.fcSearched = true;
        this.isLoading = false;
      },
      error: (err) => {
        this.buckets = null;
        this.fcSearched = true;
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load history.');
      },
    });
  }

  searchDistrict(): void {
    const d = (this.district.value || '').trim();
    if (!d || !this.districtFrom.value || !this.districtTo.value) {
      this.toastService.error('Enter district and a date range.');
      return;
    }
    this.isLoading = true;
    this.provisioningService
      .searchByDistrict(d, this.districtFrom.value, this.districtTo.value)
      .subscribe({
        next: (res: any) => {
          this.districtResults = res?.data?.requisitionDetails || [];
          this.districtSearched = true;
          this.isLoading = false;
        },
        error: (err) => {
          this.districtResults = [];
          this.districtSearched = true;
          this.isLoading = false;
          this.toastService.error(err?.error?.message || 'District search failed.');
        },
      });
  }

  sendConfirmSms(): void {
    const id = Number(this.smsBookingId.value);
    if (!id) {
      this.toastService.error('Enter a booking ID.');
      return;
    }
    this.isLoading = true;
    this.provisioningService.confirmSms(id).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.toastService.success(res?.message || 'Confirmation SMS sent.');
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to send SMS.');
      },
    });
  }
}
